import ComponentReact from './ComponentReact';

export default ComponentReact;
